export const styles = {
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
  },
  actions: {
    paddingX: 3,
    paddingBottom: 2,
    gap: 1,
  },
} as const
